import { backendReady } from "./backend";

/**
 * Anonymous use counts for the admin's Traffic page: which app page is open, a few key actions, and a "still here" signal
 * while a page is on screen. Only the page name, the action name and a random code made fresh on every page load are sent
 * (no account, no email, no cookie, nothing stored on the device); the server adds the country. It sends nothing when the
 * browser says Do Not Track or Global Privacy Control, and not in development builds.
 */
const ON = import.meta.env.PROD && backendReady;
const refuse = () => navigator.doNotTrack === "1" || (navigator as { globalPrivacyControl?: boolean }).globalPrivacyControl === true;

let sid = "";
let page = "/app";
let beating = false;

const clean = (s: string) => s.toLowerCase().replace(/[^a-z0-9-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 28);

function send(k: "view" | "click" | "ping", t = "") {
  if (!ON || refuse()) return;
  if (!sid) sid = Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => (b % 36).toString(36)).join("");
  try { void fetch("/api/account?t=1", { method: "POST", credentials: "omit", keepalive: true, body: JSON.stringify({ k, t, p: page, s: sid }) }); } catch { /* counting never gets in the way */ }
}

function beat() {
  if (beating) return;
  beating = true;
  setInterval(() => { if (!document.hidden) send("ping"); }, 30_000);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) send("ping"); });
}

/** "/car/c_12" becomes "/app/car", "/settings/units" becomes "/app/settings-units": names only, never ids. */
export function appPage(pathname: string): string {
  const [a = "", b = ""] = pathname.split("/").filter(Boolean);
  if (!a) return "/app";
  return `/app/${clean(a === "settings" && b ? `settings-${b}` : a)}`;
}

/** The page just opened (also used for the sign-in screens, as "/app/signin"). */
export function trackPage(name: string) {
  page = name;
  send("view");
  beat();
}

/** Something people did that matters: "signin", "signout", "add-car", "add-entry", "upgrade-cars"... */
export function trackAction(name: string) { send("click", clean(name)); }
